import { Check, Flower2, Leaf, Sprout, Sun } from 'lucide-react';
import type { PublicProject } from '../shared/types';
import { text, type Locale } from '../shared/content';
import { projectStage } from '../shared/project-stage';
const stages = [
  text('Prepare', '整理土地', '整理土地', 'Preparar'),
  text('Plant', '播下种子', '播下種子', 'Plantar'),
  text('Grow', '花草生长', '花草生長', 'Crecer'),
  text('Gather', '邻里相聚', '鄰里相聚', 'Reunirse'),
  text('Bloom', '花园落成', '花園落成', 'Florecer'),
];
const icons = [Leaf, Sprout, Flower2, Sun, Check];
export default function ProjectGarden({ project, locale }: { project: PublicProject; locale: Locale }) {
  const stage = projectStage(project),
    cycle = Math.min(4, Math.ceil((project.progress / Math.max(1, project.target)) * 4));
  return (
    <section
      className="project-garden"
      aria-label={
        text('Our riverfront garden', '我们的河畔花园', '我們的河畔花園', 'Nuestro jardín junto al río')[
          locale
        ]
      }
    >
      <svg viewBox="0 0 360 140" aria-hidden="true">
        <path d="M0 128 Q90 109 180 130 T360 125 V140H0Z" fill="#adbf9c" />
        <circle cx="307" cy="32" r="17" fill="#e8ca83" />
        {[0, 1, 2, 3].map((i) => (
          <g key={i} transform={`translate(${39 + i * 80} 110)`}>
            <path d="M-25 0L0-12 30 0 5 14Z" fill="#927152" />
            <path d="M-25 0V11L5 25V14Z" fill="#bd9470" />
            <path d="M5 14L30 0V11L5 25Z" fill="#a77f5b" />
            {stage > 0 && (
              <>
                <path d="M3 0V-32" stroke="#66845a" strokeWidth="3" />
                <ellipse cx="-5" cy="-16" rx="10" ry="5" transform="rotate(28 -5 -16)" fill="#8da477" />
                <ellipse cx="11" cy="-26" rx="10" ry="5" transform="rotate(-30 11 -26)" fill="#759665" />
              </>
            )}
            {stage > 1 && (
              <g transform="translate(3 -39)">
                {[0, 72, 144, 216, 288].map((a) => (
                  <ellipse
                    key={a}
                    cx="0"
                    cy="-6"
                    rx="5"
                    ry="8"
                    fill={i % 2 ? '#c48a96' : '#e1b866'}
                    transform={`rotate(${a})`}
                  />
                ))}
                <circle r="4" fill="#846b4a" />
              </g>
            )}
          </g>
        ))}
        {stage > 2 && (
          <>
            <path d="M25 64V22M335 64V22M25 22Q180 55 335 22" fill="none" stroke="#8c7960" strokeWidth="2" />
            {[0, 1, 2, 3, 4, 5, 6].map((i) => (
              <circle
                key={i}
                cx={52 + i * 43}
                cy={29 + Math.sin((i / 6) * Math.PI) * 10}
                r="3.5"
                fill="#e9d390"
              />
            ))}
          </>
        )}
      </svg>
      <div className="garden-stages">
        {stages.map((s, i) => {
          const Icon = icons[i]!;
          return (
            <div key={i} className={i <= cycle ? 'reached' : ''}>
              <Icon size={15} />
              <span>{s[locale]}</span>
            </div>
          );
        })}
      </div>
      {project.gardenUnlocked && !project.completed && (
        <p className="muted tiny">
          {
            text(
              'The garden you built stays. This week helps it keep growing.',
              '已经建好的花园会保留，本周继续一起照料它。',
              '已經建好的花園會保留，本週繼續一起照料它。',
              'El jardín construido se conserva. Esta semana seguimos cuidándolo.',
            )[locale]
          }
        </p>
      )}
    </section>
  );
}
